import {Pipe, PipeTransform} from '@angular/core';
import {
    SupportedAgeEnum,
    SupportedGenderEnum,
    VoiceBotAge,
    VoiceBotGender,
    VoiceBotLanguage,
    VoiceBotType
} from '../models/voice-bot.model';

@Pipe({
    name: 'filterVoiceBotType',
    standalone: false
})

export class FilterVoiceBotTypePipe implements PipeTransform {

    transform(voiceBotTypes: VoiceBotType[],
              voiceBotLanguage: VoiceBotLanguage,
              voiceBotGender: VoiceBotGender,
              voiceBotAge: VoiceBotAge): VoiceBotType[] {
        return voiceBotTypes.filter((voiceBotType: VoiceBotType) => {
            return voiceBotType.labels.language === voiceBotLanguage.shortName &&
                (voiceBotType.labels.gender === voiceBotGender.shortName ||
                    voiceBotGender.shortName === SupportedGenderEnum.ANY) &&
                (voiceBotType.labels.age === voiceBotAge.shortName ||
                    voiceBotAge.shortName === SupportedAgeEnum.ANY)
        })
    }
}
